import styled from "@emotion/styled";

const SubTitleWrapper = styled.div`
    label: SubTitleWrapper;

    font-family: helvetica_bold, sans-serif;
    font-size: 18px;
    letter-spacing: 0.02em;
    line-height: 40px;
    ${({ title_align }) => (title_align ? `text-align: ${title_align};` : "text-align: center;")}
`;

export default SubTitleWrapper;
